export const GET_CURRENCY_REQUESTED = 'GET_CURRENCY_REQUESTED';
export const GET_CURRENCY_SUCCEEDED = 'GET_CURRENCY_SUCCEEDED';
export const EDIT_CURRENCY_REQUESTED = 'EDIT_CURRENCY_REQUESTED';
export const EDIT_CURRENCY_SUCCEEDED = 'EDIT_CURRENCY_SUCCEEDED';
export const DELETE_CURRENCY_REQUESTED = 'DELETE_CURRENCY_REQUESTED';
export const DELETE_CURRENCY_SUCCEEDED = 'DELETE_CURRENCY_SUCCEEDED';
